export default __webpack_public_path__ + "static/media/Trio Orange - New logo.19c95fdc.png";